import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FolderAdd"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 15H18V18H15V19.5H18V22.5H19.5V19.5H22.5V18H19.5V15ZM21 6H12L9.4425 3.4425C9.16065 3.15897 8.77728 2.99968 8.3775 3H3C2.17157 3 1.5 3.67157 1.5 4.5V19.5C1.5 20.3284 2.17157 21 3 21H12V19.5H3V4.5H8.3775L10.9425 7.0575L11.3775 7.5H21V12.75H22.5V7.5C22.5 6.67157 21.8284 6 21 6Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FolderAdd.vue"]]);
